import http from '../../utils/http';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

type routeLink = string;
export type HomeState = {
  routeLink: routeLink,
  data: Object,
  detaileData: any,
  list: any, //数据列表
  searchList: any,
  searchName: string, //搜索名称
  activeIndex: number,  //移动端首页高亮点击
  activeAslideIndex: any,  //移动端首页二侧边栏高亮点击
  detaileId: number

}

export const infosAction = createAsyncThunk('users/infosAction', async () => {
  const ret = await http.post('/api/v1/scheme/category/list')
  return ret;
})
export const schemeList = createAsyncThunk('users/infosAction', async (payload?: any) => {
  const ret = await http.post('/api/v1/scheme/app/list', payload)
  return ret;
})
export const infosActionDetaile = createAsyncThunk('users/infosAction', async (payload: any) => {
  const ret = await http.FromPost('/api/v1/scheme/app/details', payload)
  return ret;
})
export const infosActionSearch = createAsyncThunk('users/infosAction', async (payload: any) => {
  const ret = await http.FromPost('/api/v1/scheme/app/search', payload)
  return ret;
})
const usersSlice = createSlice({
  name: 'home',
  initialState: {
    routeLink: '',
    data: {},
    detaileData: {} as any,
    list: [],
    searchList: [],
    searchName: "",
    activeIndex: -1,
    activeAslideIndex: [-1, -1],
    detaileId: 0,
  } as HomeState,
  reducers: {
    upRouteLink(state, action: PayloadAction<routeLink>) {
      state.routeLink = action.payload;
    },
    updateInfos(state, action: PayloadAction<Object>) {
      state.data = action.payload;
    },
    updateList(state, action: PayloadAction<Object>) {
      state.list = action.payload;
    },
    upDataSearchList(state, action: PayloadAction<any>) {
      state.searchList = action.payload;
    },

    upSearchName(state, action: PayloadAction<string>) {
      state.searchName = action.payload;
    },
    updateDetaile(state, action: PayloadAction<Object>) {
      state.detaileData = action.payload;
    },
    updateDetaileId(state, action: PayloadAction<number>) {
      state.detaileId = action.payload;
    },
    updateactiveIndexMobaile(state, action: PayloadAction<number>) {
      state.activeIndex = action.payload;
    },
    updateactiveAslideIndexMobaile(state, action: PayloadAction<any>) {
      state.activeAslideIndex = action.payload;
    },

  }
})

export const { upRouteLink, updateInfos, updateList, upDataSearchList, upSearchName, updateDetaile, updateDetaileId, updateactiveIndexMobaile, updateactiveAslideIndexMobaile } = usersSlice.actions;

export default usersSlice.reducer;